module.exports = __webpack_public_path__ + "img/com3.75f03f39.gif";